module.exports = __webpack_public_path__ + "static/media/mobile-menu-white.5d0e3a4e.svg";